import { CustomError } from './error';

import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

// datadog.loggerはサービスワーカー未対応なので、何もしない
// https://github.com/DataDog/browser-sdk/issues/432
const isSupported = typeof window !== 'undefined' && typeof document !== 'undefined';
// ローカルではconsoleに出力する
const isLocal = process.env.NODE_ENV === 'development';

export const logDebug = (message: string, payload?: object) => {
  if (isLocal || !isSupported) {
    console.debug(message, payload);
  } else {
    datadogLogs.logger.debug(message, payload);
  }
};
export const logInfo = (message: string, payload?: object) => {
  if (isLocal || !isSupported) {
    console.info(message, payload);
  } else {
    datadogLogs.logger.info(message, payload);
  }
};

const logErrorByKind = (kind: 'warn' | 'error' | 'critical', error?: unknown, payload?: object) => {
  const e = new CustomError(error, {
    meta: payload,
  });
  const msg = e.description();
  const p = e.toObject();
  switch (kind) {
    case 'warn':
      if (isLocal || !isSupported) {
        console.warn(msg, p, e);
      } else {
        datadogLogs.logger.warn(msg, p, e);
      }
      break;
    case 'error':
      if (isLocal || !isSupported) {
        console.error(msg, p, e);
      } else {
        datadogLogs.logger.error(msg, p, e);
      }
      break;
    case 'critical':
      if (isLocal || !isSupported) {
        console.error(msg, p, e);
      } else {
        datadogLogs.logger.critical(msg, p, e);
      }
      break;
  }
  if (error && isSupported) {
    datadogRum.addError(error);
  }
};

export const logWarn = (errorOrMessage?: unknown, payload?: object) => {
  logErrorByKind('warn', errorOrMessage, payload);
};

export const logError = (errorOrMessage?: unknown, payload?: object) => {
  logErrorByKind('error', errorOrMessage, payload);
};

export const logCritical = (errorOrMessage?: unknown, payload?: object) => {
  logErrorByKind('critical', errorOrMessage, payload);
};
